import { gql } from '__generated__'

export const SELLER_LIST_BUILDER_COUNT_QUERY = gql(/* GraphQL */`
  query SellerListBuilderCount($input: SellerListBuilderPreviewInput!) {
    sellerListBuilderCount(input: $input) {
      count
      estimate
    }
  }
`)
